import * as mallApis from './mall'
import * as commonApis from './common'

export {
    mallApis,
    commonApis
}
